import React from 'react';
import { ModalWrapper, ModalContent, CloseButton } from './styled/StyledLicenseExpiringModal';

const LicenseExpiringModal = ({ show, message, onClose }) => {
  return (
    <ModalWrapper show={show}>
      <ModalContent>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <p>{message}</p>
      </ModalContent>
    </ModalWrapper>
  );
};

export default LicenseExpiringModal;
